export enum widgetType {
  details,
  confirmation,
  checkout,
  checkoutDetails,
  pdp
}
